import type { DropdownOption } from '@stenajs-webui/select';
import { components, type SingleValueProps } from 'react-select';
import { CountryDropdownContent } from './CountryDropdownContent';

export const CountryDropdownSingleValue = <
  TValue extends DropdownOption<{ value: string; label: string }>,
>({
  children,
  ...optionProps
}: SingleValueProps<TValue, false>) => (
  <components.SingleValue {...optionProps}>
    <CountryDropdownContent countryCode={optionProps.data.value.toLowerCase()}>
      {children}
    </CountryDropdownContent>
  </components.SingleValue>
);
